import classNames from "classnames";
import isString from "lodash/isString";
import { IconName } from "PFTheme/graphics/icons";
import { Children } from "react";

import { ActionIcon } from "../action_icon";
import { Button, ButtonProps } from "../button";
import { Icon } from "../icon";
import { Typography } from "../typography";
import css from "./alert.module.scss";

const ICON_MAP: Record<string, IconName> = {
  error: "error",
  warning: "warning",
  success: "check",
  info: "info",
  general: "info",
  ai: "ai"
};

export type AlertProps = {
  children?: React.ReactNode;
  className?: string;
  hideIcon?: boolean;
  icon?: IconName;
  kind?: "error" | "warning" | "success" | "info" | "general" | "ai";
  qaId?: string;
  title?: string | React.ReactNode;
  multiLineTitle?: boolean;
  iconCentered?: boolean;
  action?: ButtonProps;
  /**
   * @deprecated Use className instead
   */
  style?: React.CSSProperties;
  onClose?: () => void;
};

export const Alert = ({
  children,
  className,
  hideIcon,
  icon,
  kind = "warning",
  qaId,
  title,
  multiLineTitle = false,
  iconCentered = false,
  style,
  action,
  onClose
}: AlertProps) => (
  <div
    style={style}
    data-qa-id={qaId}
    className={classNames(css.root, css[kind], { [css.withBigButton]: !!action && !action.small }, className)}
  >
    {title && (
      <div className={css.title}>
        {!hideIcon && (
          <Icon
            className={classNames(css.alertIcon, {
              [css.iconCentered]: iconCentered,
              [css.alertIconButtonAlign]:
                action && (!action?.kind || ["text", "blank"].includes(action?.kind))
            })}
            size="md"
            name={icon || ICON_MAP[kind]}
            color="paletteBlue0"
          />
        )}
        {isString(title) ? (
          <Typography
            variant={children ? "bodyBold" : "bodyRegular"}
            clipOverflow={!multiLineTitle}
            title={title}
          >
            {title}
          </Typography>
        ) : (
          title
        )}
        {action && <Button className={css.actionButton} kind="ghost" {...action} />}
        {onClose && (
          <ActionIcon classes={{ root: css.actionButton }} name="cross" onClick={onClose} size="sm" />
        )}
      </div>
    )}
    {Children.toArray(children)}
  </div>
);
